import Deposit from './deposit';
import CryptoDeposit from './crypto_deposit';
import VipDeposit from './vip_deposit';
import TrippleDeposit from './tripple_deposit';
import Games from './games';
import Facebook from './facebook';
import FacebookStream from './facebook_stream';
import FacebookStory from './facebook_story';

export default {
    Deposit,
    CryptoDeposit,
    VipDeposit,
    TrippleDeposit,
    Games,
    Facebook,
    FacebookStream,
    FacebookStory
}